import React from "react";
import { Divider, TextField, Button } from "@material-ui/core";
import banner from "./assets/contactus-banner-2.jpg";
import Call from "./assets/Call.svg";
import Email from "./assets/Email.svg";
import Location from "./assets/Location.svg";
import Aparat from "./assets/Aparat.svg";
import Instagram from "./assets/instagram.svg";
import Linkedin from "./assets/Linkedin.svg";
import Twitter from "./assets/Twitter.svg";
import Namasha from "./assets/Namasha.svg";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { createContactMessage } from "../Homepage/pages/widgets/components/cruds";
import { Formik } from "formik";
import ReactLoading from "react-loading";
import { toast, ToastContainer } from "react-toastify";
import * as Scroll from "react-scroll";
import styled from "styled-components";
import "./contact.css"

const Title = styled.h2`
  font-weight: bold;
  display:block;
  text-align:center;
  font-size: 30px;
  color:#fff;
`;

const Text = styled.p`
    font-size: 20px;
    margin-top: 20px;
    color:#fff; 
    text-align:center;  
`;

const ContactUs = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (<>
    <div className="row">
      <ToastContainer rtl={true} />
      <img className="w-100 p-0" src={banner} style={{ position: "relative", height: "350px", objectFit: "cover" }}></img>
      <div
        className="mt-20 row d-flex align-items-center justify-content-center"
        style={{
          position: "absolute",
          textAlign: "center",
          width: "100%",
        }}>
        <h1 className="text-white row d-flex align-items-center justify-content-center">
          <Title className="col-10 col-lg-9 col-xl-8 pb-10">راه‌های ارتباط با ما</Title>
          <Text className="col-10 col-md-9 col-xl-8">برای ارتباط موثر و دسترسی آسان‌تر با ایباس راه‌های ارتباطی مختلفی وجود دارد؛ که به محض به وجود اومدن مشکل یا برای پاسخگویی به سوالات احتمالی در دسترس شما باشیم.</Text>
        </h1>
      </div>

      <div className="container px-xl-30" style={{ marginBlock: "3rem 3rem" }}>
        <div className="row d-flex align-items-center justify-content-between col-md-12 m-0">
          <div className="col-md-3 col-12 px-1">
            <div className="py-0 px-4 d-flex align-items-center  mb-10 mb-md-0 bg-white" style={{ borderRadius: "15px", display: "inline-block", height: "60px", boxShadow: "0px 0px 10px lightgray" }}>
              <img src={Call} className="p-1 mr-1" style={{ width: "22px" }}></img>
              <div>تلفن پشتیبانی:
                <a href="tel:02171057305"> 02171057305</a>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12 px-1">
            <div className=" py-0 px-4 d-flex align-items-center  mb-10 mb-md-0 bg-white" style={{ borderRadius: "15px", display: "inline-block", height: "60px", boxShadow: "0px 0px 10px lightgray" }}>
              <img src={Email} className="p-1 mr-1" style={{ width: "22px" }}></img>
              <div>ایمیل: info@ebus.ir</div>
            </div>
          </div>
          <div className="col-md-3 col-12 px-1">
            <div className=" py-0 px-1 d-flex align-items-center  mb-10 mb-md-0 bg-white" style={{ borderRadius: "15px", display: "inline-block", height: "60px", boxShadow: "0px 0px 10px lightgray" }}>
              <img src={Location} className="p-1 mr-1" style={{ width: "22px" }}></img>
              <div>نشانی شرکت:   استان زنجان،خیابان وحی ساختمان پارک علم و فناوری واحد ۵</div>
            </div>
          </div>
          <div className="col-md-3 col-12 px-3">
            <div className="py-0 px-4 d-flex align-items-center  mb-10 mb-md-0 bg-white" style={{ borderRadius: "15px", display: "inline-block", height: "60px", boxShadow: "0px 0px 10px lightgray" }}>
              <img src={Call} className="p-1 mr-1" style={{ width: "22px" }}></img>
              <div>ساعات پاسخگویی: 7 روز هفته، 24 ساعت شبانه روز</div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div className="container col-12 px-0">
      <div style={{ backgroundColor: "#eee", textAlign: "center" }} className="p-6 pb-xl-26 col-12">
        <p className="col-12 p-3">نشانی دفتر مرکزی-تهران:
          ترمینال غرب، ورودی ۱۲
        </p>
        <div className="col-12 d-flex justify-content-center" style={{ height: "20rem" }}>
          <MapContainer
            center={[35.705494, 51.3305608]}
            zoom={13}
            className="w-100 h-100 col-12 col-lg-9 "
            scrollWheelZoom={false}
            style={{ zIndex: "0" }}
            attributionControl={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[35.705494, 51.3305608]}>
              <Popup>
                <b style={{ color: "#6dd06d" }}>Ebus</b>
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
    </div>

    <div className="container h-auto px-xl-30 mt-15" style={{ marginBlock: "1rem 3rem" }}>
      <div
        className="container pt-5 bg-white landings-container"
      >
        <div className="row mt-4 justify-content-center">
          <div className="col-12 row container py-5">
            <Formik
              enableReinitialize
              onSubmit={(values) => {
                setIsLoading(true);
                createContactMessage(values)
                  .then((res) => {
                    setIsLoading(false);
                    toast.success("درخواست شما ایجاد شد");
                  })
                  .catch(() => {
                    setIsLoading(false);
                    toast.error("مشکلی در ارتباط با سرور بوجود آمد");
                  });
              }}
              initialValues={{}}
            >
              {({
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                isValid,
                values,
              }) => {
                return (
                  <>
                    <div className="col-12 col-md-4 p-2 my-2">
                      <TextField
                        className="w-100 h-100"
                        id="outlined-basic"
                        label="موضوع"
                        variant="outlined"
                        onChange={(e) => {
                          setFieldValue("firstName", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-4 p-2 my-2">
                      {" "}
                      <TextField
                        className="w-100 h-100"
                        id="outlined-basic"
                        label="شماره همراه"
                        variant="outlined"
                        onChange={(e) => {
                          setFieldValue("phone", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-4 p-2 my-2">
                      <TextField
                        className="w-100 h-100"
                        id="outlined-basic"
                        label="ایمیل"
                        variant="outlined"
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-12 p-2 my-2" >
                      <TextField
                        className="w-100 h-100 discription"
                        id="outlined-basic"
                        label="پیام خود را بنویسید"
                        variant="outlined"
                        onChange={(e) => {
                          setFieldValue("subject", e.target.value);
                        }}
                      />
                    </div>
                    <div
                      className="col-12 col-md-3 p-2 my-2"
                      style={{ height: "5rem" }}
                    >
                      <Button
                        className="w-100 h-100"
                        style={{
                          backgroundColor: "#6dd06d",
                          borderRadius: "13px",
                        }}
                        onClick={() => handleSubmit()}
                      >
                        {isLoading ? (
                          <ReactLoading
                            type={"spin"}
                            color={"white"}
                            height={"10%"}
                            width={"10%"}
                          />
                        ) : (
                          <span className="my-auto mx-auto text-white">
                            ثبت
                          </span>
                        )}
                      </Button>
                    </div>
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>

    <div className="d-flex align-items-center justify-content-center row my-10">
      <p className="col-12" style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}>با ما همراه باشید</p>
      <div className="d-flex align-items-center justify-content-center col-12">
        <a href="https://twitter.com/ebus.ir">
          <img src={Twitter} className="mr-3" style={{ width: "32px" }}></img>
        </a>
        <a href="https://instagram.com/ebus.ir?utm_medium=copy_link">
          <img src={Instagram} className="mr-3" style={{ width: "32px" }}></img>
        </a>
        <a href="https://www.linkedin.com/company/ebus-ir/">
          <img src={Linkedin} className="mr-3" style={{ width: "32px" }}></img>
        </a>
        <a href="https://www.namasha.com/ebus">
          <img src={Namasha} className="mr-3" style={{ width: "32px" }}></img>
        </a>
        <a href="https://www.aparat.com/Ebus.ir">
          <img src={Aparat} className="mr-3" style={{ width: "32px" }}></img>
        </a>
      </div>
    </div>
  </>
  );
};

export default ContactUs;
